import { Modal, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import UsersIcon from "../../../assets/icons/modal-user-icon.svg";
import CatalogueIcon from "../../../assets/icons/CatalogueIcon.svg";
import CyberRangeIcon from "../../../assets/icons/modal-cyberangeicon.svg";
import MappingIcon from "../../../assets/icons/modal-vm-icon.svg";
import DocumentsIcon from "../../../assets/icons/modal-document-icon.svg";
import { useEffect, useState, useContext } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Skeleton } from "primereact/skeleton";
import AuthContext from "../../../auth/AuthContext";
import CourseService from "../../../services/CourseService";
import DocumentService from "../../../services/DocumentService";
import AlertService from "../../../services/AlertService";
import { useRef } from "react";
import { FaUpload } from "react-icons/fa";
import UserService from "../../../services/UserService";

const AddCourseModal = ({ show, handleClose, courseId, onCourseAdded }) => {
  const authContext = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);
  const [firmTypes, setFirmTypes] = useState([]);
  const [guide, setGuide] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [courseCode, setCourseCode] = useState("");
  const [clientCode, setClientCode] = useState("");
  const fileInputRef = useRef(null);
  const [logo, setLogo] = useState(null);
  const [logoName, setLogoName] = useState("");
  const [fileError, setFileError] = useState("");
  const [firmType, setFirmType] = useState(1);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [formLoading, setFormLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [labType, setLabType] = useState("");
  const [plannedStartDate, setPlannedStartDate] = useState();
  const [plannedEndDate, setPlannedEndDate] = useState();
  const [guacamoleUrl, setGuacamoleUrl] = useState();
  const [proxmoxUrl, setProxmoxUrl] = useState();
  const [nodeName, setNodeName] = useState();
  const [checkedItems, setCheckedItems] = useState({});
  const [instructors, setInstructors] = useState([]);
  const [instructorOptions, setInstructorOptions] = useState([]);
  const submitControllerRef = useRef(null);
  const [coordinators, setCoordinators] = useState([]);
  const [coordinatorOptions, setCoordinatorOptions] = useState([]);



  const handleCheckboxChange = (label, checked) => {
    setCheckedItems((prev) => ({
      ...prev,
      [label]: checked,
    }));

    if (label === "Bay") {
      if (checked) {
        setShowDropdown(true);
        setLabType("LOCAL");
      } else {
        setShowDropdown(false);
        setLabType("");
      }
    }
  };
  const validateAndConvertFile = (file) => {
    setFileError("");
    setLogo(null);
    setLogoName("");

    // Allow images only
    if (!file.type.startsWith("image/")) {
      setFileError("Please select a valid image file (PNG, JPG, etc.)");
      return;
    }
    // 1MB limit
    const maxSize = 1048576;
    if (file.size > maxSize) {
      setFileError(
        `File size (${(file.size / 1048576).toFixed(2)}MB) exceeds 1MB limit`
      );
      return;
    }
    setLogoName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => setLogo(e.target.result);
    reader.onerror = () => setFileError("Error reading file");
    reader.readAsDataURL(file);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) validateAndConvertFile(selectedFile);
  };

  const items = [
    { icon: UsersIcon, label: "Users" },
    { icon: CatalogueIcon, label: "Catalogue" },
    { icon: CyberRangeIcon, label: "Bay" },
    { icon: MappingIcon, label: "VM/User Mapping" },
    { icon: DocumentsIcon, label: "Documents" },
  ];

  const handleLabSelect = (value) => {
    setLabType(value);
  };

 useEffect(() => {
  const controller = new AbortController(); 

  const loadData = async () => {
    if (!show) return;
    resetForm();
    setFormLoading(true);

    try {
      if (courseId) {
        const data = await CourseService.Get(
          courseId,
          authContext,
          controller.signal
        );

        if (controller.signal.aborted) return; 

        if (data.isSuccess) {
          setCourseName(data.data.courseName);
          setInstructors(data.data.instructors || []);
          setCoordinators(data.data.coordinators || []);
          setCourseCode(data.data.courseCode);
          setFirmType(data.data.firmType);
          setDescription(data.data.description);
          setGuide(data.data.documents);
          setGuacamoleUrl(data.data.labUrl);
          setProxmoxUrl(data.data.proxmoxUrl);
          setNodeName(data.data.nodeName);
          setClientCode(data.data.clientCode);
          setLogo(data.data.clientLogo);
          setLogoName(data.data.clientLogoName);
          if (data.data.plannedStartDate !== null) {
            setPlannedStartDate(
              new Date(data.data.plannedStartDate.toString().substr(0, 10))
                .toISOString()
                .split("T")[0]
            );
          }
          if (data.data.plannedEndDate !== null) {
            setPlannedEndDate(
              new Date(data.data.plannedEndDate.toString().substr(0, 10))
                .toISOString()
                .split("T")[0]
            );
          }
          setIsEditing(true);
          if (data.data.labType) {
            setCheckedItems((prev) => ({ ...prev, Bay: true }));
            setShowDropdown(true);
            setLabType(data.data.labType);
          }
        } else {
          AlertService.error(data.errorMessage);
        }
      }

      if (controller.signal.aborted) return;

      const userData = await UserService.GetList(
        authContext,
        controller.signal
      );

      if (controller.signal.aborted) return;

      if (userData.isSuccess) {
        setInstructorOptions(userData.data || []);
         setCoordinatorOptions(userData.data || []); 
      } else {
        AlertService.error(userData.errorMessage);
      }

      const docData = await DocumentService.GetDocuments(
        authContext,
        controller.signal 
      );

      if (controller.signal.aborted) return; 

      if (docData.isSuccess) {
        setDocuments(docData.data);
      } else {
        AlertService.error(docData.errorMessage);
      }

      const firmData = await CourseService.GetFirmTypes(
        authContext,
        controller.signal
      );

      if (controller.signal.aborted) return;

      if (firmData.isSuccess) {
        setFirmTypes(firmData.data);
      } else {
        AlertService.error(firmData.errorMessage);
      }

    } catch (err) {
      if (err.name === "AbortError") return; 
    } finally {
      if (!controller.signal.aborted) setFormLoading(false); 
    }
  };

  loadData();

  return () => controller.abort(); 
}, [show, courseId, authContext]);

  const resetForm = () => {
    setCourseName("");
    setCourseCode("");
    setFirmType(1);
    setPlannedStartDate("");
    setPlannedEndDate("");
    setDescription("");
    setGuide([]);
    setErrors({});
    setInstructors([]);
    setCoordinators([]);
    setIsEditing(false);
    setGuacamoleUrl("");
    setProxmoxUrl("");
    setClientCode("");
    setNodeName("");
    setLogo(null);
    setCheckedItems({});
    setShowDropdown(false);
    setLabType("");
  };

  const validate = () => {
    const err = {};
    if (!courseName.trim()) {
      err.courseName = "Please provide course name";
    } else if (courseName.trim().length < 3) {
      err.courseName = "Course name must be at least 3 characters";
    }
    if (!courseCode.trim()) err.courseCode = "Please provide course code";
    else if (!/^[a-z0-9]{3,6}$/i.test(courseCode))
      err.courseCode = "Course code must be between 3 and 6 characters";
    if (!firmType) err.firmType = "Please select firm type";

   if (!plannedStartDate) {
  err.plannedStartDate = "Please select planned start date";
} else {
  const minDate = new Date("2014-01-01");

  if (new Date(plannedStartDate) < minDate) {
    err.plannedStartDate =
      "Planned start date cannot be before 2014";
  }
}

    if (!plannedEndDate) err.plannedEndDate = "Please select planned end date";
    if (
      plannedStartDate &&
      plannedEndDate &&
      new Date(plannedEndDate) < new Date(plannedStartDate)
    ) {
      err.plannedEndDate = "End date cannot be before start date";
    }
    if (!description.trim()) err.description = "Please provide description";
    setErrors(err);
    return Object.keys(err).length === 0;
  };



const onSubmitHandler = async () => {
    if (!validate()) return;
    if (submitControllerRef.current) {
      submitControllerRef.current.abort(); 
    }
    const controller = new AbortController();
    submitControllerRef.current = controller;

    setLoading(true);

    const selectedInstructorNames = instructorOptions
      .filter((opt) => instructors.includes(opt.value))
      .map((opt) => opt.label);

   const selectedCoordinatorNames = coordinatorOptions
  .filter((opt) => coordinators.includes(opt.value))
  .map((opt) => opt.label);

    const payload = {
      courseName,
      description,
      documents: guide,
      courseCode,
      firmType,
      plannedStartDate,
      plannedEndDate,
      clientCode,
      clientLogo: logo,
      clientLogoName: logoName,
      nodeName,
      attachments: [],
      instructors: instructors,
      instructorNames: selectedInstructorNames,
      coordinators: coordinators,                
      coordinatorNames: selectedCoordinatorNames ,

    };

    if (checkedItems["Bay"]) {
      payload.labType = labType;
    }
    if (isEditing && courseId) {
      payload.id = courseId;
    }
    if (payload.labType === "GUACAMOLE") {
      payload.labUrl = guacamoleUrl;
      payload.proxmoxUrl = proxmoxUrl;
    }

    try {
      const data = await CourseService.Save(
        payload,
        authContext,
        controller.signal
      );

      if (controller.signal.aborted) return;

      if (data.isSuccess) {
        AlertService.success(
          `Course ${isEditing ? "updated" : "saved"} successfully`
        );
        if (onCourseAdded) onCourseAdded();
        handleClose(true);
      } else {
        AlertService.error(data.errorMessage || "Operation failed");
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("Save error:", error);
      AlertService.error("An unexpected error occurred");
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      submitControllerRef.current?.abort();
    };
  }, []);

  // Skeleton loader for form fields
  const renderSkeletonLoader = () => (
    <div className="skeleton-loader">
      <div className="mb-4">
        <Skeleton width="120px" height="20px" className="mb-2" />
        <Skeleton width="100%" height="38px" />
      </div>
      <div className="row mb-4">
        <div className="col-md-6 mb-3 mb-md-0">
          <Skeleton width="120px" height="20px" className="mb-2" />
          <Skeleton width="100%" height="38px" />
        </div>
        <div className="col-md-6">
          <Skeleton width="120px" height="20px" className="mb-2" />
          <Skeleton width="100%" height="38px" />
        </div>
      </div>
      <div className="mb-4">
        <Skeleton width="60px" height="20px" className="mb-3" />
        <div className="d-flex flex-wrap gap-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="d-flex align-items-center">
              <Skeleton shape="circle" size="20px" className="me-2" />
              <Skeleton width="80px" height="20px" />
            </div>
          ))}
        </div>
      </div>
      <div className="mb-4">
        <Skeleton width="120px" height="20px" className="mb-2" />
        <Skeleton width="100%" height="100px" />
      </div>
      <div className="mb-4">
        <Skeleton width="150px" height="20px" className="mb-2" />
        <Skeleton width="100%" height="38px" />
      </div>
    </div>
  );

const getMinPlannedStartDate = () => "2014-01-01";

  return (
    <Modal
      show={show}
      onHide={() => handleClose(false)}
      centered
      size="xl"
      backdrop="static"
      enforceFocus={false}
    >
      <Modal.Header closeButton className="border-0 pt-4 ">
        <Modal.Title className="w-100 text-center">
          {formLoading ? (
            <Skeleton width="200px" height="30px" className="mx-auto" />
          ) : isEditing ? (
            "Edit Course"
          ) : (
            "Add New Course"
          )}
        </Modal.Title>
      </Modal.Header>

   <Modal.Body className="px-4" style={{ maxHeight: "75vh", overflowY: "auto" }}>
        {formLoading ? (
          renderSkeletonLoader()
        ) : (
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Course Name</Form.Label>
                  <Form.Control
                    className="custom-input custom-input-color"
                    type="text"
                    value={courseName}
                    onChange={(e) => {
                      setCourseName(e.target.value);
                      setErrors({ ...errors, courseName: undefined });
                    }}
                    disabled={loading}
                    isInvalid={!!errors.courseName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.courseName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Course Code</Form.Label>
                  <Form.Control
                    className="custom-input custom-input-color"
                    type="text"
                    maxLength={6}
                    value={courseCode}
                    onChange={(e) => {
                      setCourseCode(e.target.value);
                      setErrors({ ...errors, courseCode: undefined });
                    }}
                    disabled={loading}
                    isInvalid={!!errors.courseCode}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.courseCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
    <Row className="mb-3">
        <Col md={6}>
    <Form.Group className="mb-3 ">
      <Form.Label>Instructor</Form.Label>
      <MultiSelect
        value={instructors}
        options={instructorOptions}
        onChange={(e) => setInstructors(e.value)}
        optionLabel="label"
        optionValue="value" 
        className="w-100 custom-input-color"
        placeholder="Select Instructor"
        display="chip"
        filter
      />
    </Form.Group>
  </Col>
    <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Coordinator</Form.Label>
    <MultiSelect
      value={coordinators}
      options={coordinatorOptions}
      onChange={(e) => setCoordinators(e.value)}
      optionLabel="label"
      optionValue="value"
      className="w-100 custom-input-color"
      placeholder="Select Coordinator"
      display="chip"
      filter
    />
  </Form.Group>
</Col>
    <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Firm Type</Form.Label>
              <Form.Select
                className="custom-input custom-input-color"
                value={firmType}
                onChange={(e) => {
                  setFirmType(e.target.value);
                  setErrors({ ...errors, firmType: undefined });
                }}
                disabled={loading}
                isInvalid={!!errors.firmType}
              >
                {firmTypes.length > 0 ? (
                  firmTypes.map((firm, i) => (
                    <option key={i} value={firm.value}>
                      {firm.label}
                    </option>
                  ))
                ) : (
                  <option value={1}>Institute</option>
                )}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.firmType}
              </Form.Control.Feedback>
            </Form.Group>
            </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="clientCode">
                  <Form.Label>Client Code</Form.Label>
                  <Form.Control
                    className="custom-input custom-input-color"
                    type="text"
                    maxLength={6}
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value);
                      setErrors({ ...errors, clientCode: undefined });
                    }}
                    disabled={loading}
                    isInvalid={!!errors.clientCode}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="uploadLogo">
                  <Form.Label>Upload Logo</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      readOnly
                      value={logoName}
                      className="custom-input-upload custom-input-color"
                    />
                    <Button
                      variant="primary"
                      className="px-3 rounded rounded-start-0"
                      onClick={() => fileInputRef.current.click()}
                      type="button"
                    >
                      <FaUpload className="fs-6" />
                    </Button>
                    <Form.Control
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      className="d-none"
                      accept="image/*"
                    />
                  </InputGroup>
                  {fileError && (
                    <div className="text-danger small mt-1">{fileError}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="row mb-3">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label>Planned Start Date</Form.Label>
                  <Form.Control
                    className="custom-input custom-input-color"
                    type="date"
                   min={getMinPlannedStartDate()}
                    value={plannedStartDate}
                    onChange={(e) => {
                      setPlannedStartDate(e.target.value);
                      setErrors({ ...errors, plannedStartDate: undefined });
                    }}
                     onKeyDown={(e) => e.preventDefault()}
  onPaste={(e) => e.preventDefault()}
  onFocus={(e) => {
    if (e.target.showPicker) {
      e.target.showPicker();
    }
  }}
                    disabled={loading}
                    isInvalid={!!errors.plannedStartDate}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.plannedStartDate}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label>Planned End Date</Form.Label>
                  <Form.Control
                    className="custom-input custom-input-color"
                    type="date"
                    value={plannedEndDate}
                    onChange={(e) => {
                      setPlannedEndDate(e.target.value);
                      setErrors({ ...errors, plannedEndDate: undefined });
                    }}
                     onKeyDown={(e) => e.preventDefault()}
  onPaste={(e) => e.preventDefault()}
  onFocus={(e) => {
    if (e.target.showPicker) {
      e.target.showPicker();
    }
  }}
                    disabled={loading}
                    isInvalid={!!errors.plannedEndDate}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.plannedEndDate}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label>Sub-Sections</Form.Label>
              <div className="d-flex flex-wrap gap-3 gap-md-5 ms-2">
                {items.map((item, idx) => (
                  <div key={idx} className="position-relative">
                    <Form.Check
                      className="custom-input  me-2"
                      type="checkbox"
                      checked={!!checkedItems[item.label]}
                      label={
                        <>
                          <img
                            src={item.icon}
                            alt="icon"
                            className="mx-2"
                            width="20"
                          />
                          {item.label}
                        </>
                      }
                      disabled={loading}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        handleCheckboxChange(item.label, checked);
                      }}
                    />
                  </div>
                ))}
              </div>
            </Form.Group>
            {checkedItems["Bay"] && showDropdown && (
              <Form.Group className="mb-3">
                <Form.Label>Lab Type</Form.Label>
                <Form.Select
                  className="custom-input custom-input-color"
                  value={labType}
                  onChange={(e) => handleLabSelect(e.target.value)}
                >
                  <option value="LOCAL">Local</option>
                  <option value="GUACAMOLE">Guacamole</option>
                  <option value="AZURE">Azure</option>
                </Form.Select>
              </Form.Group>
            )}
            {checkedItems["Bay"] && showDropdown && labType === "GUACAMOLE" && (
              <Form.Group className="mb-3">
                <Form.Label>Node Name</Form.Label>
                <Form.Control
                  className="custom-input custom-input-color"
                  type="text"
                  value={nodeName}
                  onChange={(e) => {
                    setNodeName(e.target.value);
                    setErrors({ ...errors, nodeName: undefined });
                  }}
                  placeholder="labs"
                  disabled={loading}
                  isInvalid={!!errors.nodeName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nodeName}
                </Form.Control.Feedback>
              </Form.Group>
            )}
            {checkedItems["Bay"] && showDropdown && labType === "GUACAMOLE" && (
              <Form.Group className="mb-3">
                <Form.Label>Guacamole Url</Form.Label>
                <Form.Control
                  className="custom-input custom-input-color"
                  type="text"
                  value={guacamoleUrl}
                  onChange={(e) => {
                    setGuacamoleUrl(e.target.value);
                    setErrors({ ...errors, guacamoleUrl: undefined });
                  }}
                  placeholder="https://guac-server.thecyberbay.com/"
                  disabled={loading}
                  isInvalid={!!errors.guacamoleUrl}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.guacamoleUrl}
                </Form.Control.Feedback>
              </Form.Group>
            )}
            {checkedItems["Bay"] && showDropdown && labType === "GUACAMOLE" && (
              <Form.Group className="mb-3">
                <Form.Label>Proxmox Url</Form.Label>
                <Form.Control
                  className="custom-input custom-input-color"
                  type="text"
                  value={proxmoxUrl}
                  onChange={(e) => {
                    setProxmoxUrl(e.target.value);
                    setErrors({ ...errors, proxmoxUrl: undefined });
                  }}
                  disabled={loading}
                  placeholder="https://prox-api.thecyberbay.com/"
                  isInvalid={!!errors.proxmoxUrl}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.proxmoxUrl}
                </Form.Control.Feedback>
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                className="custom-input-color"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  setErrors({ ...errors, description: undefined });
                }}
                disabled={loading}
                isInvalid={!!errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select Documents</Form.Label>
              <MultiSelect
                value={guide}
                options={documents}
                onChange={(e) => {
                  setGuide(e.value);
                }}
                optionLabel="label"
                filter
                maxSelectedLabels={5}
                className="w-100 custom-input-color"
                placeholder="Select guides"
                disabled={loading}
                display="chip"
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 gap-3 justify-content-center justify-content-md-end  flex-wrap pb-4">
        <Button
          variant="outline-secondary"
          className="px-4 px-md-5 py-2"
          onClick={() => handleClose(false)}
          disabled={loading || formLoading}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="px-4 px-md-5 py-2"
          onClick={onSubmitHandler}
          disabled={loading || formLoading}
        >
          {loading ? (
            <span>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {isEditing ? "Updating..." : "Saving..."}
            </span>
          ) : isEditing ? (
            "Update"
          ) : (
            "Submit"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCourseModal;
